// extracted by mini-css-extract-plugin
export var active = "_cv-c";
export var compactArrow = "_cv-5";
export var container = "_cv-0";
export var dot = "_cv-b";
export var dotContainer = "_cv-a";
export var hoverArrowButton = "_cv-7";
export var hoverArrowContainer = "_cv-6";
export var leftHoverArrowContainer = "_cv-8 _cv-6";
export var rightHoverArrowContainer = "_cv-9 _cv-6";
export var slide = "_cv-4";
export var sliderContainer = "_cv-1";
export var sliderContainerVisibleOverflow = "_cv-2";
export var sliderOverflow = "_cv-3";
export var vignetteBoth = "_cv-f";
export var vignetteLeft = "_cv-e";
export var vignetteRight = "_cv-d";